import React, { forwardRef } from 'react'
import { Element, ElementProps, baseStyles } from '@theme-components/utils'
import * as Reach from '@reach/slider'

export type SliderProps = Reach.SliderProps & ElementProps

export const Slider = forwardRef<HTMLDivElement, SliderProps>((props, ref) => {
  return <Element ref={ref} as={Reach.Slider} {...props} />
})

export type SliderInputProps = Reach.SliderInputProps & ElementProps

export const SliderInput = forwardRef<HTMLDivElement, SliderInputProps>(
  (props, ref) => {
    return (
      <Element
        ref={ref}
        __css={baseStyles.sliderInput}
        __themeKey="slider"
        variant="input"
        as={Reach.SliderInput}
        {...props}
      />
    )
  }
)

export type SliderTrackProps = Reach.SliderTrackProps & ElementProps

export const SliderTrack = forwardRef<HTMLDivElement, SliderTrackProps>(
  (props, ref) => {
    return (
      <Element
        ref={ref}
        __css={baseStyles.sliderTrack}
        __themeKey="slider"
        variant="track"
        as={Reach.SliderTrack}
        {...props}
      />
    )
  }
)

export type SliderTrackHighlightProps = Reach.SliderTrackHighlightProps &
  ElementProps

export const SliderTrackHighlight = forwardRef<
  HTMLDivElement,
  SliderTrackHighlightProps
>((props, ref) => {
  return (
    <Element
      ref={ref}
      __css={baseStyles.sliderTrackHighlight}
      __themeKey="slider"
      variant="trackHighlight"
      as={Reach.SliderTrackHighlight}
      {...props}
    />
  )
})

export type SliderHandleProps = Reach.SliderHandleProps & ElementProps

export const SliderHandle = forwardRef<HTMLDivElement, SliderHandleProps>(
  (props, ref) => {
    return (
      <Element
        ref={ref}
        __css={baseStyles.sliderHandle}
        __themeKey="slider"
        variant="handle"
        as={Reach.SliderHandle}
        {...props}
      />
    )
  }
)

export type SliderMarkerProps = Reach.SliderMarkerProps & ElementProps

export const SliderMarker = forwardRef<HTMLDivElement, SliderMarkerProps>(
  (props, ref) => {
    return (
      <Element
        ref={ref}
        __css={baseStyles.sliderMarker}
        __themeKey="slider"
        variant="marker"
        as={Reach.SliderMarker}
        {...props}
      />
    )
  }
)
